import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-[#1D1D1F]">
      <header className="border-b border-[#E5E5EA]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
          <div className="text-2xl font-bold">Navirox</div>

          <nav className="flex items-center gap-6 text-sm">
            <a href="#funciones">Funciones</a>
            <a href="#sectores">Sectores</a>
            <a href="#precios">Precios</a>

            <Link
              to="/login"
              className="rounded-xl border border-[#D2D2D7] px-4 py-2"
            >
              Iniciar sesión
            </Link>

            <Link
              to="/registro"
              className="rounded-xl bg-[#0066CC] px-4 py-2 font-medium text-white"
            >
              Probar gratis
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <section className="mx-auto max-w-7xl px-6 py-24 text-center">
          <p className="mb-4 font-semibold text-[#0066CC]">
            Software de gestión de mantenimiento
          </p>

          <h1 className="mx-auto max-w-4xl text-5xl font-bold leading-tight">
            Todo tu mantenimiento.
            <br />
            En un solo lugar.
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-lg text-[#6E6E73]">
            Gestiona avisos, órdenes de trabajo, técnicos, clientes,
            mantenimientos, materiales y facturación desde una única
            plataforma.
          </p>

          <div className="mt-8 flex justify-center gap-4">
            <Link
              to="/registro"
              className="rounded-xl bg-[#0066CC] px-6 py-3 font-semibold text-white"
            >
              Probar gratis 14 días
            </Link>

            <a
              href="#precios"
              className="rounded-xl border border-[#D2D2D7] px-6 py-3 font-semibold"
            >
              Ver planes
            </a>
          </div>

          <p className="mt-4 text-sm text-[#86868B]">
            Sin permanencia · Cancela cuando quieras
          </p>
        </section>

        <section
          id="funciones"
          className="bg-[#F5F5F7] px-6 py-20"
        >
          <div className="mx-auto max-w-7xl">
            <h2 className="text-center text-3xl font-bold">
              Todo lo que necesita tu empresa
            </h2>

            <div className="mt-12 grid gap-6 md:grid-cols-3">
              {[
                ["Avisos e incidencias", "Centraliza y prioriza trabajos."],
                ["Órdenes de trabajo", "Asigna, controla y cierra intervenciones."],
                ["Técnicos", "Organiza el trabajo de tu equipo."],
                ["Mantenimiento preventivo", "Programa tareas recurrentes."],
                ["Inventario", "Controla materiales, stock y consumos."],
                ["Facturación", "Presupuestos, facturas y cobros."],
              ].map(([title, text]) => (
                <div
                  key={title}
                  className="rounded-2xl bg-white p-6 shadow-sm"
                >
                  <h3 className="text-lg font-semibold">{title}</h3>
                  <p className="mt-2 text-[#6E6E73]">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section
          id="sectores"
          className="mx-auto max-w-7xl px-6 py-20"
        >
          <h2 className="text-center text-3xl font-bold">
            Para empresas que trabajan sobre el terreno
          </h2>

          <p className="mx-auto mt-4 max-w-3xl text-center text-[#6E6E73]">
            Climatización, electricidad, fontanería, instalaciones,
            mantenimiento industrial, servicios técnicos, comunidades y
            facility management.
          </p>
        </section>

        <section
          id="precios"
          className="bg-[#F5F5F7] px-6 py-20"
        >
          <div className="mx-auto max-w-7xl">
            <h2 className="text-center text-3xl font-bold">
              Planes simples y claros
            </h2>

            <div className="mt-12 grid gap-6 md:grid-cols-3">
              {[
                ["Starter", "29 €", "Hasta 2 técnicos"],
                ["Profesional", "59 €", "Hasta 7 técnicos"],
                ["Business", "99 €", "Hasta 15 técnicos"],
              ].map(([name, price, desc]) => (
                <div
                  key={name}
                  className="rounded-2xl bg-white p-8 shadow-sm"
                >
                  <h3 className="text-2xl font-semibold">{name}</h3>
                  <p className="mt-4 text-4xl font-bold">
                    {price}
                    <span className="text-base font-normal text-[#86868B]">
                      {" "}
                      / mes
                    </span>
                  </p>
                  <p className="mt-3 text-[#6E6E73]">{desc}</p>

                  <Link
                    to="/registro"
                    className="mt-8 block rounded-xl bg-[#0066CC] px-4 py-3 text-center font-medium text-white"
                  >
                    Empezar
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-[#E5E5EA] px-6 py-8">
        <div className="mx-auto flex max-w-7xl justify-between text-sm text-[#86868B]">
          <span>© 2026 Navirox</span>
          <span>Privacidad · Términos · Contacto</span>
        </div>
      </footer>
    </div>
  );
}